import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import dayJS from 'dayjs';

import { FormComputedAsync } from '@ratehub/base-ui';

import fetchMortgageBreakagePenalty from '../functions/fetchMortgageBreakagePenalty';


function BreakagePenaltyComputed({ name, getFormValues, isDetailed }) {
    const handleFetchValue = useCallback((values) => fetchMortgageBreakagePenalty({
        detailed: isDetailed,
        principal: values.principal,
        rate: values.rate / 100,
        type: values.type,
        term: values.term * 12,
        provider: values.provider,
        province: values.province.toLowerCase(),
        startDate: dayJS(values.startDate).format('YYYY-MM-DD'),
    }), [ isDetailed ]);

    return (
        <FormComputedAsync
            name={name}
            getFormValues={getFormValues}
            onFetchValue={handleFetchValue}
            onlyWhen={hasRequiredValues}
            hidden
        />
    );
}

BreakagePenaltyComputed.propTypes = {
    name: PropTypes.string.isRequired,
    getFormValues: PropTypes.func.isRequired,
    isDetailed: PropTypes.bool,
};

BreakagePenaltyComputed.defaultProps = {
    isDetailed: true,
};

function hasRequiredValues(values, form) {
    return Object.values(values).every(value => !!value) && form.isValid;
}

export default BreakagePenaltyComputed;
